import { Component } from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import _ from "underscore";
import moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import JSONTree from "react-json-tree";

class SystemCreditsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileContent: [],
      renderedSelectedCreditStage: [],
      renderedSelectedCreditStageName: "",
      openedItem: false,
    };
  }

  render() {
    var lastInvoiceDate = new Date();
    if (lastInvoiceDate.getMonth() == 0) {
      lastInvoiceDate.setFullYear(lastInvoiceDate.getFullYear() - 1);
      lastInvoiceDate.setMonth(11);
    } else lastInvoiceDate.setMonth(lastInvoiceDate.getMonth() - 1);

    lastInvoiceDate.setDate(10);
    lastInvoiceDate.setHours(0);
    lastInvoiceDate.setMinutes(0);
    lastInvoiceDate.setSeconds(0);

    var afterLastInvoiceDateCredits = _.filter(
      this.state.fileContent,
      (itemToFilter) => {
        return new Date(itemToFilter.StateTime) > lastInvoiceDate;
      },
    );

    afterLastInvoiceDateCredits = _.groupBy(
      afterLastInvoiceDateCredits,
      (itemToGroup) => {
        return itemToGroup.CreditStage;
      },
    );

    var beforeLastInvoiceDateCredits = _.filter(
      this.state.fileContent,
      (itemToFilter) => {
        return new Date(itemToFilter.StateTime) <= lastInvoiceDate;
      },
    );

    beforeLastInvoiceDateCredits = _.groupBy(
      beforeLastInvoiceDateCredits,
      (itemToGroup) => {
        return itemToGroup.CreditStage;
      },
    );

    const modalActions = [
      <Button
        key="modal"
        variant="contained"
        color="primary"
        style={{ color: "#9e9e9e" }}
        onClick={this.handleCloseModal}
      >
        Stäng
      </Button>,
    ];

    var dialogStyles = {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    };

    return (
      <div>
        <h3>Migrated credit info view</h3>{" "}
        <Button
          variant="contained"
          color="primary"
          containerElement="label" // <-- Just add me!
          fullWidth={false}
          style={{ width: "35%" }}
        >
          Upload file (json)
          <input
            id="fileJSON"
            type="file"
            style={{ height: "0", overflow: "hidden" }}
            onChange={this.getJSONFile}
          />
        </Button>
        <br />
        <div className="row">
          <div className="col-md-6">
            <Card>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <CardHeader>After last invoice date</CardHeader>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <CardContent>
                    <div className="row">
                      {Object.keys(afterLastInvoiceDateCredits).map(
                        (creditStage, index) => {
                          return (
                            <div
                              key={`after-${creditStage}-${index}`}
                              className="col-md-4"
                              style={{ marginTop: "10px" }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                containerElement="label" // <-- Just add me!
                                fullWidth={true}
                                onClick={this.renderSpecifiedCreditStage.bind(
                                  this,
                                  afterLastInvoiceDateCredits[creditStage],
                                  creditStage,
                                )}
                              >
                                {`${creditStage} (${afterLastInvoiceDateCredits[creditStage].length})`}
                              </Button>
                            </div>
                          );
                        },
                      )}
                    </div>
                  </CardContent>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Card>
          </div>
          <div className="col-md-6">
            <Card>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <CardHeader title={"Before"}>
                    Before last invoice date
                  </CardHeader>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <CardContent>
                    <div className="row">
                      {Object.keys(beforeLastInvoiceDateCredits).map(
                        (creditStage, index) => {
                          return (
                            <div
                              key={`before-${creditStage}-${index}`}
                              className="col-md-4"
                              style={{ marginTop: "10px" }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                containerElement="label" // <-- Just add me!
                                fullWidth={true}
                                onClick={this.renderSpecifiedCreditStage.bind(
                                  this,
                                  beforeLastInvoiceDateCredits[creditStage],
                                  creditStage,
                                )}
                              >
                                {`${creditStage} (${beforeLastInvoiceDateCredits[creditStage].length})`}
                              </Button>
                            </div>
                          );
                        },
                      )}
                    </div>
                  </CardContent>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Card>
          </div>
        </div>
        <hr />
        <div className="row">
          <Dialog
            contentStyle={dialogStyles}
            actionsContainerStyle={{ textAlign: "left" }}
            autoScrollBodyContent={true}
            modal={false}
            open={this.state.openedItem}
            onClose={this.handleCloseModal}
          >
            <DialogTitle>{`Additional info ${this.state.openedItem.CreditId}`}</DialogTitle>
            <DialogContent>
              <JSONTree hideRoot={true} data={this.state.openedItem} />
            </DialogContent>
            <DialogActions>{modalActions}</DialogActions>
          </Dialog>

          <h4>{this.state.renderedSelectedCreditStageName}</h4>
          {this.state.renderedSelectedCreditStage.map((item, index) => {
            return (
              <div
                key={`rendering-${item.CreditStage}-${index}`}
                className="col-md-4"
              >
                <div
                  className="row"
                  style={{
                    margin: "10px",
                    padding: "5px",
                    border: "1px solid #303030",
                  }}
                >
                  <div className="col-md-6" style={{ fontWeight: "bold" }}>
                    Credit Amount:
                  </div>{" "}
                  <div className="col-md-6">
                    {" "}
                    {parseFloat(item.CreditAmount.Amount).toFixed(2)}
                  </div>
                  <div className="col-md-6" style={{ fontWeight: "bold" }}>
                    Due And Overdue:
                  </div>{" "}
                  <div className="col-md-6">
                    {" "}
                    {parseFloat(item.DueAndOverdue.Amount).toFixed(2)}
                  </div>
                  <div className="col-md-6" style={{ fontWeight: "bold" }}>
                    As Of Date:
                  </div>{" "}
                  <div className="col-md-6">
                    {" "}
                    {moment(item.AsOfDate).format("YYYY-MM-DD hh:mm")}
                  </div>
                  <div className="col-md-6" style={{ fontWeight: "bold" }}>
                    Capital Debt:
                  </div>{" "}
                  <div className="col-md-6">
                    {" "}
                    {parseFloat(item.CapitalDebt.Amount).toFixed(2)}
                  </div>
                  <div className="col-md-6" style={{ fontWeight: "bold" }}>
                    Credit Amount:
                  </div>{" "}
                  <div className="col-md-6">
                    {" "}
                    {parseFloat(item.CreditAmount.Amount).toFixed(2)}
                  </div>
                  <div className="col-md-6" style={{ fontWeight: "bold" }}>
                    Issue Date:
                  </div>{" "}
                  <div className="col-md-6">
                    {" "}
                    {moment(item.IssueDate).format("YYYY-MM-DD hh:mm")}
                  </div>
                  <div className="col-md-6" style={{ fontWeight: "bold" }}>
                    Total Paid:
                  </div>{" "}
                  <div className="col-md-6">
                    {" "}
                    {parseFloat(item.TotalPaid.Amount).toFixed(2)}
                  </div>
                  <div className="col-md-12" style={{ marginTop: "5px" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      containerElement="label" // <-- Just add me!
                      fullWidth={true}
                      onClick={this.getMoreInfo.bind(this, item)}
                    >
                      More info
                    </Button>
                  </div>
                  <div className="col-md-12" style={{ marginTop: "5px" }}>
                    {!this.props.accountInfos[item.AccountId] ||
                    !this.props.accountInfos[item.AccountId].data ||
                    !this.props.accountInfos[item.AccountId].data.SSN ? (
                      <div
                        className="col-md-12"
                        style={{ paddingBottom: "4px" }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          containerElement="label" // <-- Just add me!
                          fullWidth={true}
                          onClick={this.props.getAccountInfosByAccountIds.bind(
                            this,
                            [item.AccountId],
                            true,
                          )}
                        >
                          Get account info
                        </Button>
                      </div>
                    ) : (
                      <div className="col-md-12">
                        <div className="col-md-12">
                          <div
                            className="col-md-6"
                            style={{ fontWeight: "bold" }}
                          >
                            {" "}
                            SSN{" "}
                          </div>
                          <div className="col-md-6">
                            {" "}
                            {this.props.accountInfos[item.AccountId].data.SSN}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div
                            className="col-md-6"
                            style={{ fontWeight: "bold" }}
                          >
                            {" "}
                            NAME{" "}
                          </div>
                          <div className="col-md-6">
                            {" "}
                            {this.props.accountInfos[item.AccountId].data
                              .LegalEntityType === "NaturalPerson"
                              ? this.props.accountInfos[item.AccountId].data
                                  .NaturalIdentityData.IdentityName.FullName
                              : this.props.accountInfos[item.AccountId].data
                                  .OrgIdentityData.IdentityName.FullName}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  getMoreInfo = (item) => {
    this.setState({
      ...this.state,
      openedItem: item,
    });
  };

  handleCloseModal = () => {
    this.setState({
      ...this.state,
      openedItem: false,
    });
  };

  renderSpecifiedCreditStage = (data, stage) => {
    this.setState({
      ...this.state,
      renderedSelectedCreditStage: data,
      renderedSelectedCreditStageName: stage,
    });
  };

  getJSONFile = (event) => {
    var file = event.target.files[0];

    var reader = new FileReader();
    reader.onload = (e) => {
      var data = JSON.parse(e.target.result);

      this.setState({
        ...this.state,
        fileContent: data,
      });
    };
    reader.readAsBinaryString(file);
  };
}
export default SystemCreditsComponent;
